import { BRAND_COLOR, PRODUCT_TITLE } from './tenant'
import { TENANT_PALETTE } from './tenantPalette'

export const BRANDING = {
  productName: 'econworks',
  /** Stakeholder-facing product title (TopBar, tab title, footer). */
  productTitle: PRODUCT_TITLE,
  defaultBrandColor: BRAND_COLOR,
  /** The tenant chart palette (config/tenantPalette.ts — validated, brand slot 1).
   *  Users may override via Account→Theming (spec D1: override = user's responsibility). */
  defaultChipPalette: TENANT_PALETTE,
  copyrightFrom: 2026,
} as const

/** Wave-6 §1 (D2): the two-part wordmark lockup. Splits the product title on the FIRST
 *  ' — ' (the tenant title convention); no separator → single-line name, null subtitle
 *  (the env-less/Vodafone title renders exactly as before). */
export function productLockup(title: string): { name: string; subtitle: string | null } {
  const idx = title.indexOf(' — ')
  if (idx === -1) return { name: title, subtitle: null }
  return { name: title.slice(0, idx), subtitle: title.slice(idx + 3) }
}
